import { createContext } from 'react';
import { type Session, type User } from '@/lib/authClient';

interface AuthError {
  message: string;
  code: string;
}

export interface AuthContextType {
  session: Session | null;
  user: User | null;
  initialLoading: boolean;
  loading: boolean;
  requestOTP: (email: string) => Promise<{ error: AuthError | null }>;
  resendOTP: (email: string) => Promise<{ error: AuthError | null }>;
  verifyOtp: (email: string, otp: string) => Promise<{ error: AuthError | null; user: User | null }>;
  logout: () => Promise<{ error: AuthError | null }>;
  checkSession: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
